module.exports = __webpack_public_path__ + "img/icon-box.c2a769f4.svg";